import React from 'react';

import type { VisibilityProps } from '../../types/componentType';

export type { VisibilityProps };

const Visibility: React.FC<VisibilityProps> = ({
  children,
  isActive,
  className = '',
  animated = false,
  animationDuration = 300,
  role,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  'aria-live': ariaLive,
  'aria-atomic': ariaAtomic,
  'aria-busy': ariaBusy,
  'aria-hidden': ariaHidden,
}) => {
  if (!isActive) {
    // When not active, return null (removes from DOM, so no aria-hidden needed)
    return null;
  }

  const baseClasses = 'bsds-width-100';
  const combinedClasses = className ? `${baseClasses} ${className}` : baseClasses;

  const containerProps: React.HTMLAttributes<HTMLDivElement> = {
    className: combinedClasses,
    ...(role && { role }),
    ...(ariaLabel && { 'aria-label': ariaLabel }),
    ...(ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }),
    ...(ariaDescribedBy && { 'aria-describedby': ariaDescribedBy }),
    ...(ariaLive && { 'aria-live': ariaLive }),
    ...(ariaAtomic !== undefined && { 'aria-atomic': ariaAtomic }),
    ...(ariaBusy !== undefined && { 'aria-busy': ariaBusy }),
    ...(ariaHidden !== undefined && { 'aria-hidden': ariaHidden }),
  };

  if (animated) {
    return (
      <div
        {...containerProps}
        style={{ animation: `fadeIn ${animationDuration}ms ease-in-out` }}
      >
        {children}
      </div>
    );
  }

  return <div {...containerProps}>{children}</div>;
};

export default Visibility;